import * as variables from './variables.js';

import './lib/AnimationEasing';

// Polyfills
declare function require(name:string): any;
require('./polyfill/matches.js'); /* IE 11 */
require('./polyfill/closest.js'); /* IE 11 */

import "./Analytics";

import DetectBrowser from './lib/DetectBrowser';
DetectBrowser.addStyleClasses(document.documentElement);
const browserInfo = DetectBrowser.getInfo();

import ViewportTracker from './lib/ViewportTracker';
ViewportTracker.init(variables);

import {MainMenu, CollapseExpandChildrenListener } from './component/MainMenu/MainMenu';
const animationUnsupported = browserInfo.android && browserInfo.android.browserVersion === 4.0;
const mainMenu = new MainMenu({
	menu: '#menu',
	menuTriggers: '.menuTrigger--open, .menuTrigger--close, .pageOverlay',
	nodeTrigger: '.node--hasChild > a',
	styleClass: {
		menuOpen: 'hasMenuOpen',
		nodeOpen: 'isOpen'
	},
	listeners: [
		new CollapseExpandChildrenListener(animationUnsupported ? 0 : 400, 'easeOutExpo')
	]
});

// Adds classes to body as we scroll
import Scrolled from './component/Scrolled';
new Scrolled({
	scrolledClass: 'hasScrolled',
	scrolledDistanceClass: 'hasScrolledDistance',
	scrollDistanceDown: 200,
	scrollDistanceUp: 20
});

import Forms from './component/Forms';
Forms.init();

import filterArticlesForm from './component/filterArticlesForm';
new filterArticlesForm;

// CAROUSEL - Testimonials
import slickCarousel from './component/slickCarousel';
slickCarousel();

import Accordion from './component/Accordion';
new Accordion();